import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { PlusCircleIcon, XCircleIcon } from '@heroicons/react/outline'
import { departamentos, errorModal, questionModal } from "../../../../../../utils";
import { InputDate, InputDecimal, InputText, NormalButton, NormalButton2, SelectOption } from "../../../../../../ui";

export const RegistroFase6Desmembracion = ({ tab, setTab, formulario, setFormulario }) => {
  const [contador, setContador] = useState(1);
  const [desmembracion, setDesmembracion] = useState([]);
  const { register, handleSubmit, formState: { errors }, unregister, setValue } = useForm();

  useEffect(() => {
    if (formulario.desmembracion) {
      if (formulario.desmembracion.length > 0) {
        let arregloAux = [];
        for (let i = 0; i < formulario.desmembracion.length; i++) {
          arregloAux.push({ numero: i + 1 });
          setValue(`finca${i + 1}`, formulario.desmembracion[i].finca);
          setValue(`folio${i + 1}`, formulario.desmembracion[i].folio);
          setValue(`libro${i + 1}`, formulario.desmembracion[i].libro);
          setValue(`departamento${i + 1}`, formulario.desmembracion[i].departamento);
          setValue(`fecha${i + 1}`, formulario.desmembracion[i].fecha);
          setValue(`area_desmembracion${i + 1}`, formulario.desmembracion[i].area_desmembracion);
        }
        setDesmembracion(arregloAux);
        setContador(formulario.desmembracion.length + 1);
      }
    }
    // eslint-disable-next-line
  }, [])


  const agregarDesmembracion = () => {
    setDesmembracion([...desmembracion, { numero: contador }]);
    setContador(contador + 1);

  }

  const quitarDesmembracion = (item, index) => {
    if (item.numero === (contador - 1)) {
      let auxDesmembracion = [...desmembracion];
      auxDesmembracion.splice(index, 1);
      setDesmembracion(auxDesmembracion);
      unregister(`finca${item.numero}`);
      unregister(`folio${item.numero}`);
      unregister(`libro${item.numero}`);
      unregister(`departamento${item.numero}`);
      unregister(`fecha${item.numero}`);
      unregister(`area_desmembracion${item.numero}`);
      setContador(contador - 1)
    } else {
      errorModal('existen linderos posteriores a este');
    }
  }

  const almacenarDatosFormulario = (data) => {
    let desmembracion = [];
    for (let i = 1; i < contador; i++) {
      desmembracion.push({
        numero_desmembracion: i,
        finca: data[`finca${i}`],
        folio: data[`folio${i}`],
        libro: data[`libro${i}`],
        departamento: data[`departamento${i}`],
        fecha: data[`fecha${i}`],
        area_desmembracion: data[`area_desmembracion${i}`]
      })
    }
    setFormulario({ ...formulario, desmembracion });
    setTab(tab + 1);
  }

  return (
    <form onSubmit={handleSubmit((data) => almacenarDatosFormulario(data))}>
      <div className="flex flex-wrap">
        <div className='w-full pt-5 mb-4 border-b-8 border-gray-300 rounded-md flex items-center justify-center'>

          <label className=' text-center block text-2xl font-bold text-gray-400'>
            Desmembraciones
          </label>
          <button type='button' className='h-6 w-6 text-green-600 hover:-translate-y-1 hover:scale-110 ease-in-out delay-150 duration-100' onClick={agregarDesmembracion}>
            <PlusCircleIcon />
          </button>
        </div>

        {
          desmembracion.map((item, index) =>
            <div key={item.numero} className='my-4 px-1 pb-4 w-full  flex flex-wrap' >

              <div className='w-full bg-gray-400 rounded-t-xl flex items-center justify-center'>
                <label className='text-center block text-xl font-bold text-white'>
                  Desmembración No. {item.numero}
                </label>
                <button type='button' className='h-6 w-6 ml-5 text-red-600 hover:-translate-y-1 hover:scale-110 ease-in-out delay-150 duration-100' onClick={() => questionModal('Eliminar', 'Esta Seguro de Eliminar', () => { quitarDesmembracion(item, index) })}>
                  <XCircleIcon />
                </button>
              </div>

              <div className='w-full flex border-x-4 border-b-4 border-gray-400 rounded-b-xl shadow-lg p-2'>
                <div className='flex flex-wrap w-full'>
                  <InputText nameLabel='Finca' register={register} name={`finca${item.numero}`} message="El registro de finca es obligatorio" errors={errors} Placeholder="Ej. 7718" position="md:w-1/4" />
                  <InputText nameLabel='Folio' register={register} name={`folio${item.numero}`} message="El registro del folio es obligatorio" errors={errors} Placeholder="Ej. 218" position="md:w-1/4" />
                  <InputText nameLabel='Libro' register={register} name={`libro${item.numero}`} message="El registro del libro es obligatorio" errors={errors} Placeholder="Ej. 116E" position="md:w-1/4" />
                  <SelectOption nameLabel='Departamento' register={register} name={`departamento${item.numero}`} message='El departamento es requerido' errors={errors} array={departamentos} valueOption='departamento' nameOption='departamento' position="md:w-1/4"/>
                  <InputDate nameLabel='Fecha' register={register} name={`fecha${item.numero}`} message='La fecha es requerida' errors={errors} position="md:w-1/2" />
                  <InputDecimal nameLabel='Área m2' register={register} name={`area_desmembracion${item.numero}`} message="El área es requerida" errors={errors} Placeholder="Ej. 624.90" position="md:w-1/2" />
                </div>
              </div>
            </div>
          )
        }

        <div className="w-full mx-3 mt-5 text-center flex justify-end">
          <NormalButton funcion={() => setTab(tab - 1)} bgColor='bg-red-700' bgText='text-white font-semibold' hoverColor='hover:bg-red-800' dimension="mr-1 px-1 sm:px-6 py-2 rounded-md cursor-pointer" title={
            <div className="flex">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
              Anterior
            </div>
          } />

          <NormalButton2 typeButton="submit" bgColor='bg-blue-900' bgText='text-white font-semibold' hoverColor='hover:bg-blue-800' dimension="mr-1 px-1 sm:px-6 py-2 rounded-md cursor-pointer" title={
            <div className="flex">
              Siguiente
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </div>
          } />
        </div>
      </div>
    </form>
  )
}
